import Moment from 'moment';

// Formateo de los datos que UserForm muestra como texto (modo lectura y email del usuario de acceso en el alta).

export const EmptyDisplayValue = "—";

/**
 * Valor de texto para mostrar: el valor sin espacios en los extremos o "—" si está vacío.
 */
export const formatDisplayValue = (value: string | null | undefined): string =>
{
    const trimmed = (value ?? '').trim();
    return trimmed === '' ? EmptyDisplayValue : trimmed;
};

/**
 * Fecha en formato dd/MM/yyyy o "—" si no hay fecha válida.
 */
export const formatDisplayDate = (value: Date | string | null | undefined): string =>
{
    if(value === null || value === undefined || value === '')
    {
        return EmptyDisplayValue;
    }
    const date = Moment(value);
    return date.isValid() ? date.format('DD/MM/YYYY') : EmptyDisplayValue;
};

/**
 * Teléfono con su prefijo delante ("+34 600111222"). Sin teléfono devuelve "—"; si el teléfono ya trae
 * el prefijo no se duplica.
 */
export const formatDisplayPhone = (countryPrefix: string | null | undefined, phone: string | null | undefined): string =>
{
    const trimmedPhone = (phone ?? '').trim();
    if(trimmedPhone === '')
    {
        return EmptyDisplayValue;
    }

    const trimmedPrefix = (countryPrefix ?? '').trim();
    if(trimmedPrefix === '')
    {
        return trimmedPhone;
    }

    const phoneWithoutPrefix = trimmedPhone.startsWith(trimmedPrefix) ? trimmedPhone.substring(trimmedPrefix.length).trim() : trimmedPhone;
    return phoneWithoutPrefix === '' ? EmptyDisplayValue : `${trimmedPrefix} ${phoneWithoutPrefix}`;
};
